import React from 'react'
import SlotCards from './SlotCards'
import SlotList from './SlotList'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

export default function AllSlotsTab ({ slots, boxes }) {
  const screens = useBreakpoint()

  return (
    <>
      {screens.xs && <SlotCards slots={slots} boxes={boxes} />}
      {!screens.xs && <SlotList slots={slots} boxes={boxes} />}
    </>
  )
}
